import React from "react";
import { connect } from "react-redux";
import { getOptionsData } from "../../redux/options/options.selectors";

const Desklist = (props) => {
  const toggelShortcutEnabled = () => {
    let data = JSON.parse(JSON.stringify(props.optionsData));
    data.dse = !data.dse;
    props.setOptionsData(data);
  };

  return (
    <>
      <span className="closeChat">{props.optionsData.dcc.toString()}</span>
      <span className="delayChat">{props.optionsData.ddc.toString()}</span>
      <span className="gameChat">{props.optionsData.dgc.toString()}</span>
      <span className="openChat">{props.optionsData.doc.toString()}</span>
      <span className="sendChat">{props.optionsData.dsc.toString()}</span>
      <span className="shortcutMode">{props.optionsData.shc.toString()}</span>
      <span className="shortcutToggle">{props.optionsData.dst.toString()}</span>
      <span className="shortcutEnabled" onClick={toggelShortcutEnabled}>{props.optionsData.dse.toString()}</span>
    </>
  );
};

const mapStateToProps = (state) => ({
  optionsData: getOptionsData(state)
});

export default connect(mapStateToProps, null)(Desklist);
